// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__HsJRz"};